import axios from "axios";
import { BACKEND_URL } from "../utils/api";
export const authService = {
  async login(email: string, password: string) {
    try {
      const response = await axios.post(`${BACKEND_URL}/user/login`, {
        email,
        password,
      });

      console.log("login-response", response);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
